export const DEFAULT_SEARCH_LIST = [
  'ins风,简约,时尚',
  '简约,泰式风,大气',
  '高定任选',
  '求婚,对戒'
]
